<template>
  <div class="container">
    <div class="row">
      <div class="form-group col-md-6">
        <label class="control-label">
          ¿ Tiene empresas, sociedades o asociaciones ?
        </label>
        <p-radio
          class="d-inline-block"
          v-model="bandera"
          label="1"
        >Si</p-radio>
        <p-radio
          class="d-inline-block"
          v-model="bandera"
          label="0"
        >No</p-radio>
      </div>
    </div>
    <div v-if="bandera == '1'">
      <div v-if="add_item">
        <div class="row">
          <legend>Empresas, Sociedades o Asociaciones </legend>
        </div>
        <div class="row">
          <div class="form-group col-md-12">
            <label class="control-label">
              ¿ Estas de acuerdo en hacer pública la información de tu posible conflicto de interés ?
            </label>
            <p-radio
              name="es_publica"
              v-validate="item_empresasValidations.es_publica"
              v-model="item_empresas.es_publica"
              :inline=true
              label="1"
            >Si</p-radio>
            <p-radio
              name="es_publica"
              v-validate="item_empresasValidations.es_publica"
              v-model="item_empresas.es_publica"
              :inline=true
              label="2"
            >No</p-radio>
            <small
              class="text-danger"
              v-show="es_publica.invalid"
            >
              {{ getError('es_publica') }}
            </small>
          </div>
          <div class="form-group col-md-4">
            <label class="control-label">Tipo de Operación</label>
            <el-select
              filterable
              class="select-default"
              placeholder="Seleccione una opción"
              name="tipo_operacion_id"
              v-validate="item_empresasValidations.tipo_operacion_id"
              v-model="item_empresas.tipo_operacion_id"
            >
              <el-option
                v-for="option in operaciones"
                class="select-default"
                :value="option.id"
                :label="option.valor"
                :key="option.label"
              ></el-option>
            </el-select><small
              class="text-danger"
              v-show="tipo_operacion_id.invalid"
            >
              {{ getError('tipo_operacion_id') }}
            </small>
          </div>
          <div class="form-group col-md-8">
            <label class="control-label">Nombre de la empresa, sociedad o asociación</label>
            <input
              class="form-control"
              type="text"
              name="nombre_empresa_sociedad_asociacion"
              v-validate="item_empresasValidations.nombre_empresa_sociedad_asociacion"
              v-model="item_empresas.nombre_empresa_sociedad_asociacion"
              placeholder="Nombre de la empresa"
            ><small
              class="text-danger"
              v-show="nombre_empresa_sociedad_asociacion.invalid"
            >
              {{ getError('nombre_empresa_sociedad_asociacion') }}
            </small>
          </div>

          <div class="form-group col-md-4">
            <label class="control-label">Frecuencia Anual</label>
            <el-select
              filterable
              class="select-default"
              placeholder="Seleccione una opción"
              name="frecuencia_anual_id"
              v-validate="item_empresasValidations.frecuencia_anual_id"
              v-model="item_empresas.frecuencia_anual_id"
            >
              <el-option
                v-for="option in frecuencias"
                class="select-default"
                :value="option.id"
                :label="option.valor"
                :key="option.label"
              ></el-option>
            </el-select><small
              class="text-danger"
              v-show="frecuencia_anual_id.invalid"
            >
              {{ getError('frecuencia_anual_id') }}
            </small>
          </div>

          <div
            class="form-group col-md-8"
            v-if=" item_empresas.frecuencia_anual_id == 6"
          >
            <label class="control-label">Especificar frecuencia anual</label>
            <input
              class="form-control"
              type="text"
              name="frecuencia_anual_especificar"
              v-validate="item_empresasValidations.frecuencia_anual_especificar"
              v-model="item_empresas.frecuencia_anual_especificar"
              placeholder="Especificar"
            ><small
              class="text-danger"
              v-show="frecuencia_anual_especificar.invalid"
            >
              {{ getError('frecuencia_anual_especificar') }}
            </small>
          </div>

          <div class="form-group col-md-4">
            <label class="control-label">Tipo de persona Juridica</label>
            <el-select
              filterable
              class="select-default"
              placeholder="Seleccione una opción"
              name="persona_juridica"
              v-validate="item_empresasValidations.persona_juridica"
              v-model="item_empresas.persona_juridica"
            >
              <el-option
                v-for="option in personas"
                class="select-default"
                :value="option.id"
                :label="option.valor"
                :key="option.label"
              ></el-option>
            </el-select><small
              class="text-danger"
              v-show="persona_juridica.invalid"
            >
              {{ getError('persona_juridica') }}
            </small>
          </div>

          <div
            class="form-group col-md-4"
            v-if=" item_empresas.persona_juridica == 8"
          >
            <label class="control-label">Especifique</label>
            <input
              class="form-control"
              type="text"
              name="otra_persona_juridica"
              v-validate="item_empresasValidations.otra_persona_juridica"
              v-model="item_empresas.otra_persona_juridica"
              placeholder="Especificar"
            ><small
              class="text-danger"
              v-show="otra_persona_juridica.invalid"
            >
              {{ getError('otra_persona_juridica') }}
            </small>
          </div>
          <div class="form-group col-md-4">
            <label class="control-label">Responsable del posible conflicto de interés</label>
            <el-select
              filterable
              class="select-default"
              placeholder="Seleccione una opción"
              name="responsable_conflicto"
              v-validate="item_empresasValidations.responsable_conflicto"
              v-model="item_empresas.responsable_conflicto"
            >
              <el-option
                v-for="option in responsables"
                class="select-default"
                :value="option.id"
                :label="option.valor"
                :key="option.label"
              ></el-option>
            </el-select><small
              class="text-danger"
              v-show="responsable_conflicto.invalid"
            >
              {{ getError('responsable_conflicto') }}
            </small>
          </div>
          <div class="form-group col-md-4">
            <label class="control-label">Naturaleza del vínculo</label>
            <el-select
              filterable
              class="select-default"
              placeholder="Seleccione una opción"
              name="naturaleza_vinculo"
              v-validate="item_empresasValidations.naturaleza_vinculo"
              v-model="item_empresas.naturaleza_vinculo"
            >
              <el-option
                v-for="option in naturalezas"
                class="select-default"
                :value="option.id"
                :label="option.valor"
                :key="option.label"
              ></el-option>
            </el-select><small
              class="text-danger"
              v-show="naturaleza_vinculo.invalid"
            >
              {{ getError('naturaleza_vinculo') }}
            </small>
          </div>
          <div
            class="form-group col-md-4"
            v-if=" item_empresas.naturaleza_vinculo == 3"
          >
            <label class="control-label">Especifique</label>
            <input
              class="form-control"
              type="text"
              name="otra_persona_juridica"
              v-validate="item_empresasValidations.naturaleza_vinculo_especificar"
              v-model="item_empresas.naturaleza_vinculo_especificar"
              placeholder="Especificar"
            ><small
              class="text-danger"
              v-show="naturaleza_vinculo_especificar.invalid"
            >
              {{ getError('naturaleza_vinculo_especificar') }}
            </small>
          </div>
          <div class="form-group col-md-4">
            <label class="control-label">Antigüedad del Vinculo (Años)</label>
            <input
              class="form-control"
              type="number"
              name="antiguedad_vinculo"
              v-validate="item_empresasValidations.antiguedad_vinculo"
              v-model="item_empresas.antiguedad_vinculo"
              placeholder="Antigüedad del vinculo"
            ><small
              class="text-danger"
              v-show="antiguedad_vinculo.invalid"
            >
              {{ getError('antiguedad_vinculo') }}
            </small>
          </div>
          <div class="form-group col-md-4">
            <label class="control-label">
              Participación en la dirección o administración:
            </label>
            <br>
            <div>
              <p-radio
                name="participacion"
                v-validate="item_empresasValidations.participacion"
                v-model="item_empresas.participacion"
                :inline=true
                label="1"
              >Antes del servicio público</p-radio>
              <p-radio
                name="participacion"
                v-validate="item_empresasValidations.participacion"
                v-model="item_empresas.participacion"
                :inline=true
                label="2"
              >Después del servicio público</p-radio>
            </div>
            <small
              class="text-danger"
              v-show="participacion.invalid"
            >
              {{ getError('participacion') }}
            </small>

          </div>

          <div class="form-group col-md-4">
            <label class="control-label">Tipo de colaboración o aporte</label>
            <el-select
              filterable
              class="select-default"
              placeholder="Seleccione una opción"
              name="tipo_colaboracion"
              v-validate="item_empresasValidations.tipo_colaboracion"
              v-model="item_empresas.tipo_colaboracion"
            >
              <el-option
                v-for="option in colaboraciones"
                class="select-default"
                :value="option.id"
                :label="option.valor"
                :key="option.label"
              ></el-option>
            </el-select><small
              class="text-danger"
              v-show="tipo_colaboracion.invalid"
            >
              {{ getError('tipo_colaboracion') }}
            </small>
          </div>

          <div
            class="form-group col-md-4"
            v-if=" item_empresas.tipo_colaboracion == 5"
          >
            <label class="control-label">Especifique</label>
            <input
              class="form-control"
              type="text"
              name="tipo_colaboracion_especificar"
              v-validate="item_empresasValidations.tipo_colaboracion_especificar"
              v-model="item_empresas.tipo_colaboracion_especificar"
              placeholder="Especificar"
            ><small
              class="text-danger"
              v-show="tipo_colaboracion_especificar.invalid"
            >
              {{ getError('tipo_colaboracion_especificar') }}
            </small>
          </div>
        </div>

        <domicilio
          titulo="del bien"
          v-model="n_domicilio"
        ></domicilio>

        <div class="row justify-content-end m-3">
          <button
            class="btn btn-success"
            @click.prevent="addItem()"
          >
            <span v-if="edit_item == null">
              <i class="fa fa-plus"></i> Guardar
            </span>

            <span v-else>
              <i class="fa fa-save"></i> Guardar
            </span>
          </button>
          <button
            class="btn btn-danger ml-3"
            @click.prevent="cancelEdit()"
          >
            <span>
              <i class="fa fa-times"></i> Cancelar
            </span>
          </button>
        </div>
        <div class="row">
          <hr class="col-md-12 bg-info">
        </div>
      </div>

      <div v-if="!add_item">
        <div class="row justify-content-end m-3">
          <button
            class="btn btn-primary"
            @click.prevent="showItem()"
          >
            <span>
              <i class="fa fa-plus"></i> Agregar
            </span>
          </button>
        </div>
        <div class="row mt-3 mb-4">

          <div class="col-sm-12 col-md-12 col-lg-12">
            <b-table
              id="tbl_metales"
              responsive
              hover
              :items="list_empresas"
              :fields="fields_list"
              show-empty
            >
              <!-- :fields="fields_list" -->
              <template
                slot="acciones"
                slot-scope="row"
                class="actions"
              >
                <b-button
                  size="sm"
                  @click.prevent="editItem(row)"
                  class="edit mr-2"
                  :disabled="edit_item != null"
                >
                  Editar <i class="fas fa-pencil-alt ml-2"></i>
                </b-button>
                <b-button
                  size="sm"
                  @click.prevent="removeItem(row.index)"
                  class="delete mr-2"
                  :disabled="edit_item != null"
                >
                  Eliminar <i class="fas fa-trash-alt ml-2"></i>
                </b-button>
              </template>
              <template slot="empty">
                <h5>No existen registros</h5>
              </template>
              <template
                slot="domicilio_entidad_federativa_id"
                slot-scope="row"
              >
                {{getEntidad(row.item.domicilio_entidad_federativa_id)}}</template>
              <template
                slot="domicilio_localidad_id"
                slot-scope="row"
              >
                {{getLocalidad(row.item.domicilio_localidad_id)}}
              </template>
              <template
                slot="domicilio_municipio_id"
                slot-scope="row"
              >{{getMunicipio(row.item.domicilio_municipio_id)}}</template>
              <template
                slot="domicilio_pais_id"
                slot-scope="row"
              >{{getPais(row.item.domicilio_pais_id)}}</template>
              <template
                slot="pais_registro_id"
                slot-scope="row"
              >{{getPais(row.item.pais_registro_id)}}</template>

              <template
                slot="tipo_operacion_id"
                slot-scope="row"
              >{{getOperacion(row.item.tipo_operacion_id)}}</template>
              <template
                slot="frecuencia_anual_id"
                slot-scope="row"
              >{{getFrecuencia(row.item.frecuencia_anual_id)}}</template>
              <template
                slot="persona_juridica"
                slot-scope="row"
              >{{getPersonas(row.item.persona_juridica)}}</template>
              <template
                slot="responsable_conflicto"
                slot-scope="row"
              >{{getResponsables(row.item.responsable_conflicto)}}</template>
              <template
                slot="naturaleza_vinculo"
                slot-scope="row"
              >{{getNaturalezas(row.item.naturaleza_vinculo)}}</template>
              <template
                slot="actividad_economica"
                slot-scope="row"
              >{{getBool(row.item.actividad_economica)}}</template>
              <template
                slot="participacion"
                slot-scope="row"
              >{{getParticipacion(row.item.participacion)}}</template>
              <template
                slot="tipo_colaboracion"
                slot-scope="row"
              >{{getColaboraciones(row.item.tipo_colaboracion)}}</template>
            </b-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Tag, Select, DatePicker, InputNumber } from "element-ui";
import { mapFields } from "vee-validate";

import Domicilio from "../Domicilio.vue";
export default {
  components: {
    [Tag.name]: Tag,
    [DatePicker.name]: DatePicker,
    [InputNumber.name]: InputNumber,
    Domicilio
  },
  props: ["data"],
  data() {
    return {
      validaciones: {
        rfc: false
      },
      operaciones: null,
      frecuencias: null,
      personas: null,
      responsables: null,
      naturalezas: null,
      colaboraciones: null,
      ip_id: 1,
      add_item: false,
      edit_item: null,
      bandera: "0",
      sectores: null,
      n_domicilio: null,
      actividad_economica: null,
      monedas: [],
      entidadFed: null,
      municipios: null,
      localidades: null,
      localidad: null,
      paises: null,
      isnum: null,
      actividad: [
        {
          text: "Si",
          value: true
        },
        {
          text: "No",
          value: false
        }
      ],
      /* Lista de metales */
      item_empresas: {},
      list_empresas: [],
      item_empresasValidations: {
        nombre_empresa_sociedad_asociacion: {
          required: true
        },
        tipo_operacion_id: {
          required: true
        },
        frecuencia_anual_id: {
          required: true
        },
        frecuencia_anual_especificar: {
          required: true
        },
        persona_juridica: {
          required: true
        },
        otra_persona_juridica: {
          required: true
        },
        responsable_conflicto: {
          required: true
        },
        naturaleza_vinculo: {
          required: true
        },
        naturaleza_vinculo_especificar: {
          required: true
        },
        antiguedad_vinculo: {
          required: true
        },
        participacion: {
          required: true
        },
        tipo_colaboracion: {
          required: true
        },
        tipo_colaboracion_especificar: {
          required: true
        },
        es_publica: {
          required: true
        }
      },
      fields_list: [
        {
          key: "acciones",
          label: "Acciones",
          tdClass: "text-center"
        },
        {
          key: "tipo_operacion_id",
          label: "Tipo de Operación",
          tdClass: "text-left",
          formatter: "emptyFields"
        },
        {
          key: "nombre_empresa_sociedad_asociacion",
          label: "Nombre de la empresa",
          tdClass: "text-left",
          formatter: "emptyFields"
        },
        {
          key: "frecuencia_anual_id",
          label: "Frecuencia Anual",
          tdClass: "text-left",
          formatter: "emptyFields"
        },
        {
          key: "frecuencia_anual_especificar",
          label: "Otra (Especifique)",
          tdClass: "text-left",
          formatter: "emptyFields"
        },
        {
          key: "persona_juridica",
          label: "Tipo de persona jurídica",
          tdClass: "text-center",
          formatter: "emptyFields"
        },
        {
          key: "otra_persona_juridica",
          label: "Otra (Especifique)",
          tdClass: "text-right",
          formatter: "emptyFields"
        },
        {
          key: "responsable_conflicto",
          label: "Responsable del posible conflicto de interés",
          tdClass: "text-left",
          formatter: "emptyFields"
        },
        {
          key: "naturaleza_vinculo",
          label: "Naturaleza del vínculo",
          tdClass: "text-left",
          formatter: "emptyFields"
        },
        {
          key: "naturaleza_vinculo_especificar",
          label: "Otro-Especificar",
          tdClass: "text-left",
          formatter: "emptyFields"
        },
        {
          key: "antiguedad_vinculo",
          label: "Antigüedad del vínculo (Años)",
          tdClass: "text-right",
          formatter: "emptyFields"
        },
        {
          key: "participacion",
          label: "Participación en la dirección",
          tdClass: "text-center",
          formatter: "emptyFields"
        },
        {
          key: "tipo_colaboracion",
          label: "Tipo de colaboración o aporte",
          tdClass: "text-center",
          formatter: "emptyFields"
        },
        {
          key: "tipo_colaboracion_especificar",
          label: "Otros aportes(especifica)",
          tdClass: "text-center",
          formatter: "emptyFields"
        },
        {
          key: "domicilio_pais_id",
          label: "Pais",
          tdClass: "text-left",
          formatter: "emptyFields"
        },
        {
          key: "domicilio_entidad_federativa_id",
          label: "Entidad federativa",
          tdClass: "text-left",
          formatter: "emptyFields"
        },
        {
          key: "domicilio_municipio_id",
          label: "Municipio",
          tdClass: "text-left",
          formatter: "emptyFields"
        },
        {
          key: "domicilio_localidad_id",
          label: "Localidad",
          tdClass: "text-left",
          formatter: "emptyFields"
        },
        {
          key: "domicilio_colonia",
          label: "Colonia",
          tdClass: "text-left",
          formatter: "emptyFields"
        },
        {
          key: "domicilio_vialidad_tipo",
          label: "Tipo vialidad",
          tdClass: "text-left",
          formatter: "emptyFields"
        },
        {
          key: "domicilio_vialidad_nombre",
          label: "Nombre vialidad",
          tdClass: "text-left",
          formatter: "emptyFields"
        },
        {
          key: "domicilio_cp",
          label: "CP",
          tdClass: "text-right",
          formatter: "emptyFields"
        },
        {
          key: "domicilio_numext",
          label: "Número Exterior",
          tdClass: "text-right",
          formatter: "emptyFields"
        },
        {
          key: "domicilio_numint",
          label: "Número Interior",
          tdClass: "text-right",
          formatter: "emptyFields"
        }
      ]
    };
  },
  computed: {
    ...mapFields([
      "nombre_empresa_sociedad_asociacion",
      "tipo_operacion_id",
      "frecuencia_anual_id",
      "frecuencia_anual_especificar",
      "persona_juridica",
      "otra_persona_juridica",
      "responsable_conflicto",
      "naturaleza_vinculo",
      "naturaleza_vinculo_especificar",
      "antiguedad_vinculo",
      "participacion",
      "tipo_colaboracion",
      "tipo_colaboracion_especificar",
      "es_publica"
    ])
  },
  watch: {
    n_domicilio: {
      handler: function() {
        if (this.n_domicilio) {
          this.item_empresas.domicilio_pais_id = this.n_domicilio.pais_id
            ? this.n_domicilio.pais_id
            : 150;
          this.item_empresas.domicilio_entidad_federativa_id = this.n_domicilio
            .entidadF
            ? this.n_domicilio.entidadF
            : "";
          this.item_empresas.domicilio_municipio_id = this.n_domicilio.municipio
            ? this.n_domicilio.municipio
            : "";
          this.item_empresas.domicilio_localidad_id = this.n_domicilio.localidad
            ? this.n_domicilio.localidad
            : "";
          this.item_empresas.domicilio_cp = this.n_domicilio.cp
            ? this.n_domicilio.cp
            : "";
          this.item_empresas.domicilio_colonia = this.n_domicilio.colonia
            ? this.n_domicilio.colonia
            : "";
          this.item_empresas.domicilio_vialidad_tipo = this.n_domicilio.vialidad
            ? this.n_domicilio.vialidad
            : "";
          this.item_empresas.domicilio_vialidad_nombre = this.n_domicilio
            .vialidad_nombre
            ? this.n_domicilio.vialidad_nombre
            : "";
          this.item_empresas.domicilio_numext = this.n_domicilio.ext
            ? this.n_domicilio.ext
            : "";
          this.item_empresas.domicilio_numint = this.n_domicilio.int
            ? this.n_domicilio.int
            : "";
        }
      },
      deep: true
    },
    list_empresas: {
      handler: function() {
        if (this.list_empresas) {
          this.setLocalidades();
          if (this.list_empresas.length == 0) {
            this.bandera = "0";
          } else {
            this.bandera = "1";
          }
        }
      },
      deep: true
    },
    item_empresas: {
      handler: function() {
        if (this.item_empresas) {
          this.actividad_economica =
            "" + this.item_empresas.actividad_economica;
        }
      },
      deep: true
    },
    actividad_economica() {
      this.item_empresas.actividad_economica = this.actividad_economica;
    }
  },
  methods: {
    emptyFields(value) {
      if (value) {
        if (typeof value === "string" || value instanceof String) {
          return value.toUpperCase();
        } else {
          return value;
        }
      } else {
        return "-";
      }
    },
    getBool(index) {
      var resp = "No";
      if (index == 1 || index == "1") {
        resp = "Si";
        return resp;
      }
      return resp;
    },
    getParticipacion(index) {
      var resp = "No";
      if (index == 1) {
        resp = "Antes del servicio público";
        return resp;
      } else {
        resp = "Después del servicio público";
        return resp;
      }
      return resp;
    },
    getSector(index) {
      var resp = " ";
      if (this.sectores) {
        this.sectores.forEach(function(item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    getEntidad(index) {
      var resp = " ";
      if (this.entidadFed) {
        this.entidadFed.forEach(function(item) {
          if (item.id == index) {
            resp = item.nom_ent;
            return resp;
          }
        });
      }
      return resp;
    },
    getLocalidad(index) {
      var resp = "";
      if (this.localidades) {
        this.localidades.forEach(function(item) {
          if (item.id == index) {
            resp = item.nom_loc;
            return resp;
          }
        });
      }
      return resp;
    },
    getMunicipio(index) {
      var resp = "";
      if (this.municipios) {
        this.municipios.forEach(function(item) {
          if (item.id == index) {
            resp = item.nom_mun;
            return resp;
          }
        });
      }
      return resp;
    },
    getPais(index) {
      var resp = "México";
      if (this.paises) {
        this.paises.forEach(function(item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    getOperacion(index) {
      var resp = " ";
      if (this.operaciones) {
        this.operaciones.forEach(function(item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    getFrecuencia(index) {
      var resp = " ";
      if (this.frecuencias) {
        this.frecuencias.forEach(function(item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    getPersonas(index) {
      var resp = " ";
      if (this.personas) {
        this.personas.forEach(function(item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    getResponsables(index) {
      var resp = " ";
      if (this.responsables) {
        this.responsables.forEach(function(item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    getNaturalezas(index) {
      var resp = " ";
      if (this.naturalezas) {
        this.naturalezas.forEach(function(item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    getColaboraciones(index) {
      var resp = " ";
      if (this.colaboraciones) {
        this.colaboraciones.forEach(function(item) {
          if (item.id == index) {
            resp = item.valor;
            return resp;
          }
        });
      }
      return resp;
    },
    initItem() {
      this.n_domicilio = {
        pais_id: 150,
        entidadF: "",
        municipio: "",
        localidad: "",
        cp: "",
        colonia: "",
        vialidad: "",
        vialidad_nombre: "",
        ext: "",
        int: ""
      };
      this.item_empresas = {
        acciones: "",
        actividad_economica: "1",
        nombre_empresa_sociedad_asociacion: "",
        pais_registro_id: 150,
        fecha_constitucion: "",
        numero_registro: "",
        rfc: "",
        rol: "",
        sector_industria_id: "",
        porcentaje_participacion: 100,
        domicilio_pais_id: 150,
        domicilio_entidad_federativa_id: "",
        domicilio_municipio_id: "",
        domicilio_localidad_id: "",
        domicilio_colonia: "",
        domicilio_cp: "",
        domicilio_numext: "",
        domicilio_numint: "",
        domicilio_vialidad_nombre: "",
        domicilio_vialidad_tipo: ""
      };
    },
    showItem() {
      this.add_item = !this.add_item;
    },
    cancelEdit() {
      if (this.edit_item) {
        this.edit_item.item._rowVariant = "";
      }
      this.initItem();
      this.showItem();
      this.edit_item = null;
    },
    addItem() {
      this.$validator.validateAll().then(response => {
        if (response) {
          if (this.item_empresas) {
            this.item_empresas.ip_id = this.ip_id;
            this.loadButton(this.$refs.btnSave);
            this.$http.post("empresas", this.item_empresas).then(
              response => {
                this.StepOk("Guardado");
                if (this.edit_item === undefined || this.edit_item === null) {
                  this.list_empresas.push({
                    ...response.data.empresa
                  });
                } else {
                  this.list_empresas.splice(
                    this.edit_item.index,
                    1,
                    this.item_empresas
                  );
                  this.edit_item.item._rowVariant = "";
                }
                this.initItem();
                this.showItem();
                this.edit_item = null;
              },
              error => {
                this.StepW(error);
                //this.change =  true;
              }
            );
          }
        } else {
          this.StepW("Hay campos sin completar");
        }
      });
      //console.log(this.item_empresas);
    },
    editItem(indice) {
      this.showItem();
      this.edit_item = indice;
      this.item_empresas = {
        ...this.list_empresas[this.edit_item.index]
      };
      this.editDomicilio();
      this.edit_item.item._rowVariant = "danger";
      $(".main-panel").animate(
        {
          scrollTop: 100
        },
        500,
        "swing"
      );
    },
    removeItem(indice) {
      if (this.list_empresas[indice].id !== null) {
        let item = this.list_empresas[indice];
        this.list_empresas.splice(indice, 1);
        this.Ask("Desea borrar este registro", () => {
          this.$http.delete("empresas/" + item.id).then(
            response => {
              /* eventBus.$emit("Empresas", item); */
              this.list_empresas.splice(indice, 1);
            },
            error => {
              this.Err(error);
            }
          );
        });
      }
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate() {
      return this.$validator.validateAll();

      if (this.add_item) {
        this.validaciones = {
          rfc: false
        };
        if (!this.rfcValido(this.item_empresas.rfc)) {
          this.validaciones.rfc = true;
          return false;
        }
      }
    },
    editDomicilio() {
      this.n_domicilio.pais_id = this.item_empresas.domicilio_pais_id
        ? this.item_empresas.domicilio_pais_id
        : 150;
      this.n_domicilio.entidadF = this.item_empresas
        .domicilio_entidad_federativa_id
        ? this.item_empresas.domicilio_entidad_federativa_id
        : "";
      this.n_domicilio.municipio = this.item_empresas.domicilio_municipio_id
        ? this.item_empresas.domicilio_municipio_id
        : "";
      this.n_domicilio.localidad = this.item_empresas.domicilio_localidad_id
        ? this.item_empresas.domicilio_localidad_id
        : "";
      this.n_domicilio.cp = this.item_empresas.domicilio_cp
        ? this.item_empresas.domicilio_cp
        : "";
      this.n_domicilio.colonia = this.item_empresas.domicilio_colonia
        ? this.item_empresas.domicilio_colonia
        : "";
      this.n_domicilio.vialidad = this.item_empresas.domicilio_vialidad_tipo
        ? this.item_empresas.domicilio_vialidad_tipo
        : "";
      this.n_domicilio.vialidad_nombre = this.item_empresas
        .domicilio_vialidad_nombre
        ? this.item_empresas.domicilio_vialidad_nombre
        : "";
      this.n_domicilio.ext = this.item_empresas.domicilio_numext
        ? this.item_empresas.domicilio_numext
        : "";
      this.n_domicilio.int = this.item_empresas.domicilio_numint
        ? this.item_empresas.domicilio_numint
        : "";
    },
    setLocalidades() {
      this.localidades = [];
      if (this.list_empresas) {
        this.list_empresas.forEach(item => {
          if (item.domicilio_localidad_id) {
            this.$http
              .get("localidades/localidad/" + item.domicilio_localidad_id)
              .then(
                response => {
                  this.localidades.push(response.data.localidad);
                },
                error => {
                  this.Err(error);
                }
              );
          }
        });
      }
    },
    isNumber(n) {
      //console.log(n);
      n.target.value = n.target.value.replace(/[^\d.-]/g, "");
    }
  },
  created() {
    this.initItem();
    //this.getLocalidades(97250);
    this.$http.get("empresas/" + this.ip_id).then(
      response => {
        this.list_empresas = response.data.empresas;
        this.setLocalidades();
      },
      error => {
        this.Err(error);
      }
    );
    this.$http.get("entidadFed").then(
      response => {
        this.entidadFed = response.data.entidadfed;
      },
      error => {
        this.Err(error);
      }
    );
    this.$http.get("paises").then(
      response => {
        this.paises = response.data.pais;
      },
      error => {
        this.Err(error);
      }
    );
    this.$http.get("municipios").then(
      response => {
        this.municipios = response.data.municipios;
      },
      error => {
        this.Err(error);
      }
    );
    this.$http.get("cat_sector_industria").then(
      response => {
        this.sectores = response.data.sectores;
      },
      error => {
        this.Err(error);
      }
    );
    this.$http.get("cat_tipo_operacion_interes").then(
      response => {
        this.operaciones = response.data.tipos;
      },
      error => {
        this.Err(error);
      }
    );
    this.$http.get("cat_frecuencia_anual").then(
      response => {
        this.frecuencias = response.data.tipos;
      },
      error => {
        this.Err(error);
      }
    );
    this.$http.get("getPersonas").then(
      response => {
        this.personas = response.data.personas;
      },
      error => {
        this.Err(error);
      }
    );
    this.$http.get("cat_titular").then(
      response => {
        this.responsables = response.data.titulares;
      },
      error => {
        this.Err(error);
      }
    );
    this.$http.get("getNaturalezas").then(
      response => {
        this.naturalezas = response.data.naturalezas;
      },
      error => {
        this.Err(error);
      }
    );
    this.$http.get("getColaboraciones").then(
      response => {
        this.colaboraciones = response.data.colaboraciones;
      },
      error => {
        this.Err(error);
      }
    );
    if (this.data) {
    }
  }
};
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Forms/Formularios/Intereses/InteresesEmpresas.vue